export default "__VITE_ASSET__BRCEOcLO__"